import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';


export interface MenuMoreOption {
  id: number;
  text: string;
  icon: string;
  alt: string,
  class?: string;
}

@Component({
  selector: 'app-more-options-table-row',
  templateUrl: './more-options-table-row.component.html',
  styleUrls: ['./more-options-table-row.component.scss']
})
export class MoreOptionsTableRowComponent {

  @Input()
  maxWidth: string = "";

  @Input()
  top: string = "0px";

  @Input()
  right: string = "29px";

  uniqueId: string = uuidv4();

  openDropdown: boolean = false;

  @Input() menuOptions: MenuMoreOption[] = [];

  @Output()
  optionEmitter = new EventEmitter()

  constructor(private translateService: TranslateService) {

  }

  ngOnInit() {
    if (this.menuOptions == null || this.menuOptions?.length == 0) {
      // DEFAULT OPTIONS AND EXAMPLE OF OPTIONS TODO ON PARENT COMPONENTE
      this.menuOptions = [
        { id: 1, text: this.translateService.instant('MORE_OPTIONS.EDIT'), icon: 'assets/icons/pencil-alt.svg', alt: this.translateService.instant('MORE_OPTIONS.EDIT') },
        { id: 2, text: this.translateService.instant('MORE_OPTIONS.DETAIL'), icon: 'assets/icons/datatable-eye.svg', alt: this.translateService.instant('MORE_OPTIONS.DETAIL') },
        { id: 3, text: this.translateService.instant('MORE_OPTIONS.DELETE'), icon: 'assets/icons/datatable-trash-red.svg', alt: this.translateService.instant('MORE_OPTIONS.DELETE'), class: 'red-span' }
      ]
    }
  }

  toggleDropdown() {
    this.openDropdown = !this.openDropdown;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const element = document.getElementById(`${this.uniqueId}`);
    if (element && !element.contains(targetElement)) {
      this.openDropdown = false;
    }
  }

  optionEmit(event: number) {
    this.optionEmitter.emit(event)
    this.openDropdown = false;
  }
}
